import(/* webpackMode: "eager" */ "/opt/actions-runner/_work/website/website/components/CTA/CTA.scss");
;
import(/* webpackMode: "eager" */ "/opt/actions-runner/_work/website/website/components/Dashboards/Dashboards.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/actions-runner/_work/website/website/components/Double/Double.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/actions-runner/_work/website/website/components/GenericHero/GenericHero.js");
;
import(/* webpackMode: "eager" */ "/opt/actions-runner/_work/website/website/components/Integrations/Integrations.js");
;
import(/* webpackMode: "eager" */ "/opt/actions-runner/_work/website/website/components/PlatformHero/PlatformHero.js");
;
import(/* webpackMode: "eager" */ "/opt/actions-runner/_work/website/website/components/StorylaneHero/StorylaneHero.js");
;
import(/* webpackMode: "eager" */ "/opt/actions-runner/_work/website/website/node_modules/next/dist/client/link.js");
